import { api } from './api';

const taxConfigService = {
  // Get all tax configurations
  async getAllTaxConfigs(params = {}) {
    try {
      console.log('Calling GET /tax-config with params:', params);
      const response = await api.get('/tax-config', { params });
      console.log('🔍 Tax Config Raw API response:', response);
      console.log('🔍 Tax Config Response data:', response.data);
      
      // Handle different response structures
      let configs;
      if (response.data?.status === 'success' && response.data?.data) {
        // Handle {status: 'success', data: [...]} structure
        configs = response.data.data;
        console.log('📦 Extracted tax configs from response.data.data:', configs);
      } else if (response.data?.data) {
        // Handle {data: [...]} structure
        configs = response.data.data;
        console.log('📦 Extracted tax configs from response.data.data (fallback):', configs);
      } else if (Array.isArray(response.data)) {
        // Handle direct array response
        configs = response.data;
        console.log('📦 Using response.data directly as array:', configs);
      } else {
        console.warn('⚠️ Unrecognized tax config response structure:', response.data);
        configs = [];
      }
      
      // Ensure we return a valid array
      const validConfigs = Array.isArray(configs) ? configs.filter(config => {
        const isValid = config && config.regionCode && config.regionName;
        if (!isValid) {
          console.warn('⚠️ Invalid tax config found:', config);
        }
        return isValid;
      }) : [];
      
      console.log('✅ Final valid tax configs:', validConfigs);
      return validConfigs;
    } catch (error) {
      console.error('❌ Error in getAllTaxConfigs:', error);
      return [];
    }
  },

  // Get tax configuration by ID
  async getTaxConfigById(id) {
    try {
      const response = await api.get(`/tax-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get tax configuration by region
  async getTaxConfigByRegion(regionCode) {
    try {
      const response = await api.get(`/tax-config/region/${regionCode}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get tax configurations by country
  async getTaxConfigsByCountry(countryCode) {
    try {
      const response = await api.get(`/tax-config/country/${countryCode}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all tax templates
  async getTaxTemplates() {
    try {
      console.log('Calling GET /tax-config/templates');
      const response = await api.get('/tax-config/templates');
      console.log('Templates response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getTaxTemplates:', error);
      throw error;
    }
  },

  // Create new tax configuration
  async createTaxConfig(data) {
    try {
      const response = await api.post('/tax-config', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create tax configuration from template
  async createFromTemplate(data) {
    try {
      const response = await api.post('/tax-config/from-template', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update tax configuration
  async updateTaxConfig(id, data) {
    try {
      const response = await api.put(`/tax-config/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete tax configuration
  async deleteTaxConfig(id) {
    try {
      const response = await api.delete(`/tax-config/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add tax type to configuration
  async addTaxType(configId, taxTypeData) {
    try {
      const response = await api.post(`/tax-config/${configId}/tax-type`, taxTypeData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update tax type
  async updateTaxType(configId, taxTypeId, data) {
    try {
      const response = await api.put(`/tax-config/${configId}/tax-type/${taxTypeId}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Remove tax type
  async removeTaxType(configId, taxTypeId) {
    try {
      const response = await api.delete(`/tax-config/${configId}/tax-type/${taxTypeId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Calculate tax
  async calculateTax(configId, data) {
    try {
      const response = await api.post(`/tax-config/${configId}/calculate`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Initialize templates
  async initializeTemplates() {
    try {
      const response = await api.post('/tax-config/initialize-templates');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Validate tax configuration
  async validateTaxConfiguration() {
    try {
      console.log('Calling GET /tax-config/validate');
      const response = await api.get('/tax-config/validate');
      console.log('Validation response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in validateTaxConfiguration:', error);
      throw error;
    }
  }
};

export default taxConfigService;